import { REFERRAL_ORIGIN } from "@/config/api";

const trimSlash = (value = "") => value.replace(/\/$/, "");

/** Build a shareable campaign deep-link from a referral token. */
export function buildReferralUrl(token) {
  if (!token) return "";
  return `${trimSlash(REFERRAL_ORIGIN)}/r/${token}`;
}

/** Prefer env-based origin over API placeholder URLs (e.g. api.proovam.com). */
export function resolveReferralUrl(apiUrl, token) {
  const built = buildReferralUrl(token);
  if (!apiUrl) return built;
  if (/api\.proovam\.com/i.test(apiUrl) && built) return built;
  return apiUrl;
}
